<template>
    <div>
        <div class="flex justify-between items-center space-x-2">
            <div @click="routeTo('products.index')">Home</div>
            <div
                class="border border-gray-300 px-2 py-0.5 rounded"
                @click="showCategories = true"
            >
                Categories
            </div>
        </div>

        <div
            class="fixed inset-0 z-30 overflow-y-auto duration-300 ease-out transform bg-white"
            :class="showCategories ? 'translate-y-0' : 'translate-y-full'"
        >
            <div class="flex items-center justify-between h-12 px-4 py-2 shadow">
                <h2 class="text-lg font-bold">Categories</h2>
                <div @click="showCategories = false">
                    <CloseIcon class="w-6 fill-current" />
                </div>
            </div>

            <div class="">
                <CollapsableListItem
                    v-for="parentCategory in categoriesGroupedByParent"
                    :key="'parentCategory-' + parentCategory.id"
                    :title="parentCategory.name"
                    class="px-4 py-2 border border-bottom border-gray-200"
                >
                    <template #content>
                        <ul class="p-2 bg-gray-100 rounded">
                            <li
                                v-for="category in parentCategory.children"
                                class="underline mb-2 text-green-600"
                                @click="routeTo('products.index', { categoryIds: [category.id] })"
                            >
                                {{ category.name }}
                            </li>
                        </ul>
                    </template>
                </CollapsableListItem>

                <CollapsableListItem
                    v-if="wholesalers.length"
                    title="Wholesalers"
                    class="px-4 py-2 border border-bottom border-gray-200"
                >
                    <template #content>
                        <ul class="p-2 bg-gray-100 rounded">
                            <li
                                v-for="wholesaler in wholesalers"
                                class="underline mb-2 text-green-600"
                                @click="routeTo('products.index', { wholesalerIds: [wholesaler.id] })"
                            >
                                {{ wholesaler.name }}
                            </li>
                        </ul>
                    </template>
                </CollapsableListItem>
            </div>
        </div>
    </div>
</template>

<script>
    import CollapsableListItem from './CollapsableListItem.vue';
    import CloseIcon from './Icons/CloseIcon.vue';

    export default {
        name: 'CategoryHamburger',

        components: {
            CloseIcon,
            CollapsableListItem,
        },

        data() {
            return {
                showCategories: false,

                categoriesGroupedByParent: [],
                wholesalers: [],
            };
        },

        async beforeMount() {
            await this.fetchCategoriesGroupedByParent();
            await this.fetchWholesalers();
        },

        methods: {
            async fetchCategoriesGroupedByParent() {
                await this.$axios.get(route('categories.groupByParent')).then((res) => {
                    this.categoriesGroupedByParent = res.data.categoriesGroupedByParent;
                });
            },

            async fetchWholesalers() {
                await this.$axios.get(route('wholesalers.index')).then((res) => {
                    this.wholesalers = res.data.wholesalers;
                });
            },

            routeTo(path, params = {}) {
                this.$inertia.get(route(path, params));
                this.showCategories = false;
            },
        },
    };
</script>

<style></style>
